<template>
  <content-wrapper>
    <Content
        class="mt-3"
    >
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">User</h6>
            </b-col>
            <b-col md="1">
              <b-button variant="outline-light" @click="add()">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>

        <!-- Table Search -->
        <b-row>
          <b-col v-if="isSuperAdmin">
            <b-form-group
                label-for="memberDropdown"
                label="Select Member"
            >
              <MemberDropDown id="memberDropdown"
                              v-model="selectedMember"
                              :member="member"
                              @change="loadUserByMember"
                              :show-super-admin="true"
              ></MemberDropDown>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label="User Status"
                label-for="memberStatus"
            >
              <b-form-radio-group
                  id="memberStatus"
                  buttons
                  button-variant="outline-primary"
                  :options="options.user"
                  name="radios-btn-direction"
                  v-model="searchForm.status"
                  @change="pagination.current = 1;loadUserByMember(selectedMember)"
                  class="mb-3"
                  :disabled="isDisabled"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label="Search Username"
                label-for="memberStatus"
            >
              
            <!-- Search User -->
            <b-input-group class="d-flex">
              <!-- <b-dropdown
                variant="outline-secondary"
                :text="selectedCategory"
                class="me-2"
                toggle-class="w-100"
              >
                <b-dropdown-item
                  v-for="category in categories"
                  :key="category"
                  @click="selectCategory(category)"
                >
                  {{ category }}
                </b-dropdown-item>
              </b-dropdown> -->

              <b-form-input
                placeholder="Search ..."
                v-model="searchQuery"
                @keyup.enter="handleSearch"
              />
                <b-input-group-append>
                  <b-button variant="primary" @click="handleSearch">
                    <b-icon icon="search" />
                  </b-button>
                </b-input-group-append>
            </b-input-group>
            <!-- end Search User -->

          </b-form-group>
            
          </b-col>
        </b-row>

        <div class="table-responsive">
          <!-- table -->
          <b-table :per-page="pagination.per_page"
                  :current-page="pagination.current"
                  ref="table"
                  :items="loadPage"
                  :fields="columns"
                  :busy.sync="isLoading"
                  striped
                  borderless
                  outlined
                  hover
                  show-empty
                  empty-text="No records found..."
                  stacked="sm"
                  class="mb-3"
          >
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner label="Loading..." type="grow"></b-spinner>
              </div>
            </template>

            <!-- level -->
            <template #cell(level)="data">
              {{ 
                data.value === 1 ? 'Super Admin'
                : data.value === 2 ? 'Admin'
                : data.value === 3 ? 'Normal User'
                : data.value === 4 ? 'Control Room'
                : data.value === 5 ? 'Gate Pass'
                : data.value 
              }}
            </template>
            
            <!-- status -->
            <template #cell(status)="data">
              <b-badge :variant="status[0][data.value]">
                {{ status[1][data.value] }}
              </b-badge>
            </template>

            <!-- full Details on click -->
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col
                      md="6"
                      class="mb-1"
                  >
                    <dl>
                      <dt>Company Name</dt>
                      <dd>{{ row.item.member.company_name }}</dd>
                      <dt>NIB</dt>
                      <dd>{{ row.item.member.NIB }}</dd>
                      <dt>NPWP</dt>
                      <dd>{{ row.item.member.NPWP }}</dd>
                    </dl>
                  </b-col>
                  <b-col
                      md="6"
                      class="mb-1"
                  >
                    <dl>
                      <dt>Expiry</dt>
                      <dd>{{ typeof row.item.expiry === 'string' ? row.item.expiry.replace(/\+.*/, '') : '-' }}</dd>
                      <dt>Renewal</dt>
                      <dd>{{ typeof row.item.renewal === 'string' ? row.item.renewal.replace(/\+.*/, '') : '-' }}</dd>
                      <dt>Status</dt>
                      <dd>
                        <b-badge :variant="status[0][row.item.status]">
                          {{ status[1][row.item.status] }}
                        </b-badge>
                      </dd>
                    </dl>
                  </b-col>
                </b-row>

                <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="row.toggleDetails"
                >
                  Hide Details
                </b-button>
              </b-card>
            </template>
            
            <!-- Details button to click-->
            <template #cell(actions)="data">
              <div class="action-btn-group">
                <b-button class="text-nowrap"
                size="sm"
                    :variant="data.item.status === 1 ? 'secondary' : 'info' "
                    @click="setStatus(data.item)"
                >{{ data.item.status === 1 ? 'Disable Me' : 'Enable Me' }}
                </b-button>
                <b-button
                size="sm"
                    :variant="'primary'"
                    @click="editUser(data.item)"
                >{{'Edit'}}
                </b-button>
                <b-button
                size="sm"
                    v-if="can('superadmin')"
                    :variant="'danger'"
                    @click="deleteUser(data.item)"
                >{{'Delete'}}
                </b-button>

                <!-- trigger Detail collapse -->
                <!-- <b-button
                  size="sm"
                  variant="link"
                  @click="data.toggleDetails"
                  :aria-controls="'row-details-'+data.index"
                >
                  <span>
                    {{ data.detailsShowing ? 'Details' : 'Details' }}
                    <b-icon :icon="data.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                  </span>  
                </b-button> -->
              </div>
            </template>

          </b-table>
        </div>

        <!-- pagination -->
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>

    <!-- Modals  -->
    <b-modal
        header-bg-variant="secondary"
        centered id="formModal" size="lg"
        title="User Form"
        no-close-on-esc
        hide-header-close
        no-close-on-backdrop
    >

      <!-- here -->
      <b-form-group
          label="Member"
          label-for="member"
          v-if="isSuperAdmin"
      >
        <MemberDropDown
            v-model="selectedMember"
            :member="member"
            @change="setMember"
            :show-super-admin="true"
            type="tes"
        ></MemberDropDown>
      </b-form-group>
      <!-- ./here -->

      <b-row>
        <b-col>
          <b-form-group
              label="Username"
              label-for="username"
              label-class="required"
          >
            <b-form-input
                id="username"
                v-model="$v.user.username.$model"
                required
                type="text"
                :state="validateState('username')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field and must be at least 3 characters.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Email"
              label-for="email"
              label-class="required"
          >
            <b-form-input
                id="email"
                v-model="$v.user.user_mail.$model"
                type="email"
                :state="validateState('user_mail')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field, must be at least 5 characters and a valid email.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Access Level"
              label-for="level"
              label-class="required"
          >
            <b-form-select
                :options="level"
                v-model="$v.user.level.$model"
            ></b-form-select>
            <b-form-invalid-feedback>
              This is a required field
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" :disabled="isSubmitting" @click="submit()">
          Submit
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="clearForm();cancel()">
          Forget it
        </b-button>
      </template>
    </b-modal>

    <!-- Image Preview Modal -->
    <b-modal v-model="showImageModal" size="xl" hide-footer centered title="Preview Image">
      <div class="d-flex justify-content-center">
        <img :src="imagePreviewSrc" alt="Preview" style="max-width:100%; max-height:80vh; object-fit:contain;" />
      </div>
    </b-modal>
    <!-- Credential Modal -->
    <b-modal centered header-bg-variant="success" id="credential" size="sm" title="Keep this password" ok-only
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel()">
          OK!
        </b-button>
      </template>
    </b-modal>

    <!-- Detail Member Modal -->
    <b-modal
      v-model="showDetailModal"
      title="👤 User Detail"
      hide-footer
      centered
      size="md"
      content-class="p-0 rounded-3 shadow"
    >
      <div v-if="isDetailLoading" class="d-flex flex-column align-items-center justify-content-center p-5">
        <b-spinner type="grow" class="mb-3" />
        <span class="text-muted">Loading user details...</span>
      </div>

      <b-card
        v-else-if="selectedUser"
        class="border-0 rounded-3 m-0 p-0"
        body-class="p-0"
      >
         <!-- USER SECTION -->
        <div class="pl-4">
          <div class="d-flex align-items-center mb-4" style="gap:10px;">
            <b-avatar
              variant="primary"
              size="3rem"
              class="me-3"
              :text="selectedUser.username ? selectedUser.username.charAt(0).toUpperCase() : '?'"
            ></b-avatar>
            <div>
              <h5 class="mb-0">{{ selectedUser.username }}</h5>
              <div class="text-muted small">{{ selectedUser.user_mail }}</div>
            </div>
          </div>
          <b-row>
            <b-col cols="3" class="mb-3">
              <div class="text-center text-muted small">Level</div>
              <div class="d-flex justify-content-center">
                <b-badge variant="info" pill>
                  {{ selectedUser.level === 1 ? 'Super Admin'
                    : selectedUser.level === 2 ? 'Admin'
                    : selectedUser.level === 3 ? 'Normal User'
                    : selectedUser.level === 4 ? 'Control Room'
                    : selectedUser.level === 5 ? 'Gate Pass'
                    : selectedUser.level }}
                </b-badge>
              </div>
            </b-col>
            <b-col cols="3" class="mb-3">
              <div class="text-nowrap text-center text-muted small">User Status</div>
              <div class="d-flex justify-content-center">
                <b-badge
                  class="ms-auto"
                  :variant="status[0][selectedUser.status]"
                  pill
                >
                  {{ status[1][selectedUser.status] }}
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- BORDER PEMBATAS -->
        <hr class="m-0" />

        <!-- MEMBER SECTION -->
        <div class="p-4 bg-light">
          <div class="fw-semibold text-uppercase text-secondary" style="font-size: 0.95rem; letter-spacing: 1px;">
            Member Info
          </div>
          <b-row>
            <b-col cols="12" class="mb-2">
              <div class="text-muted small">Company</div>
              <div class="fw-semibold">
                {{ selectedUser.member ? selectedUser.member.company_name : '-' }}
              </div>
            </b-col>
            <b-col cols="6" class="mb-3">
              <div class="text-muted small">NIB</div>
              <div>{{ selectedUser.member ? selectedUser.member.NIB : '-' }}</div>
            </b-col>
            <b-col cols="6" class="mb-3">
              <div class="text-muted small">NPWP</div>
              <div>{{ selectedUser.member ? selectedUser.member.NPWP : '-' }}</div>
            </b-col>
            <b-col cols="6" class="mb-3">
              <div class="text-muted small">Member Since</div>
              <div>{{ selectedUser.member ? selectedUser.member.member_since : '-' }}</div>
            </b-col>
          </b-row>
          <b-row>

            <!-- SIM -->
            <b-col cols="6" class="mb-3">
              <figure class="figure" v-if="selectedUser && selectedUser.sim">
                <figcaption class="figure-caption text-center mb-2">SIM</figcaption>
                <img 
                  v-if="selectedUser.sim"
                  :src="selectedUser.sim" 
                  class="figure-img img-fluid rounded border img-clickable user-doc-image" 
                  alt="SIM"
                  @click="openImagePreview(selectedUser.sim)"
                >
              </figure>
              <figure class="figure text-muted" v-else>
                <figcaption class="figure-caption text-center">SIM</figcaption>
                <div 
                  class="figure-img img-fluid rounded d-flex align-items-center justify-content-center border user-doc-placeholder p-4 text-center">No SIM image</div>
              </figure>
              <!-- File upload for SIM -->
              <div v-if="can('superadmin|memberadmin')">
                <b-form-file
                  accept="image/*"
                  @change="onSimFileChange"
                ></b-form-file>
                <div class="mt-2 d-flex" style="gap:5px;">
                  <b-button size="sm" variant="primary" @click="uploadSingleFile('sim')">Upload SIM</b-button>
                  <b-button size="sm" variant="secondary" class="ms-2" v-if="selectedUser && selectedUser.simPreview" @click.prevent="selectedUser.simPreview=null;selectedUser.simFile=null">Clear</b-button>
                </div>
                <div v-if="selectedUser && selectedUser.simPreview" class="mt-2">
                  <small class="text-muted">Preview:</small>
                  <img :src="selectedUser.simPreview" class="img-fluid rounded d-block mt-1 img-clickable" style="width:120px; height:90px; object-fit:cover;" alt="SIM preview" @click="openImagePreview(selectedUser.simPreview)" />
                </div>
              </div>
            </b-col>

            <!-- KTP -->
            <b-col cols="6" class="mb-3">
              <figure class="figure" v-if="selectedUser && selectedUser.ktp">
                <figcaption class="figure-caption text-center mb-2">KTP</figcaption>
                <img 
                  v-if="selectedUser.ktp"
                  :src="selectedUser.ktp" 
                  class="figure-img img-fluid rounded border img-clickable user-doc-image" 
                  alt="KTP"
                  @click="openImagePreview(selectedUser.ktp)"
                >
              </figure>
              <figure class="figure text-muted" v-else>
                <figcaption class="figure-caption text-center">KTP</figcaption>
                <div 
                  class="figure-img img-fluid rounded d-flex align-items-center justify-content-center border user-doc-placeholder p-4 text-center">No KTP image</div>
              </figure>
              <!-- File upload for KTP -->
              <div v-if="can('superadmin|memberadmin')">
                <b-form-file
                  accept="image/*"
                  @change="onKtpFileChange"
                ></b-form-file>
                <div class="mt-2 d-flex" style="gap:5px;">
                  <b-button size="sm" variant="primary" @click="uploadSingleFile('ktp')">Upload KTP</b-button>
                  <b-button size="sm" variant="secondary" class="ms-2" v-if="selectedUser && selectedUser.ktpPreview" @click.prevent="selectedUser.ktpPreview=null;selectedUser.ktpFile=null">Clear</b-button>
                </div>
                <div v-if="selectedUser && selectedUser.ktpPreview" class="mt-2">
                  <small class="text-muted">Preview:</small>
                  <img :src="selectedUser.ktpPreview" class="img-fluid rounded d-block mt-1 img-clickable" style="width:120px; height:90px; object-fit:cover;" alt="KTP preview" @click="openImagePreview(selectedUser.ktpPreview)" />
                </div>
              </div>
            </b-col>

          </b-row>
        </div>

        <hr v-if="can('superadmin')"  class="my-0" />

        <!-- section update role -->
        <b-row v-if="can('superadmin')" class="px-4 py-2 mb-2">
          <b-form-group
            label="Select Access Level"
            label-for="level"
            class="w-100"
          >
            <b-form-select
                :options="level"
                v-model="$v.user.level.$model"
                @change="changeLevel"
                class="w-100"
            ></b-form-select>
            <b-form-invalid-feedback>
              This is a required field
            </b-form-invalid-feedback>
          </b-form-group>
          <b-button
            :variant="'primary'"
            :size="'sm'"
            @click="updateAccessLevelUser(selectedUser.id)"
          >{{'Change Access Level'}}
          </b-button>
        </b-row>

        <hr v-if="can('superadmin')"  class="my-2" />

        <!-- section update member -->
        <b-row v-if="can('superadmin')" class="px-4 py-4">
          <b-form-group
              label="Select Member"
              label-for="member"
              v-if="isSuperAdmin"
              class="w-100"
          >
            <MemberDropDown
                type="tes"
                @change="changeMember"
                :member="member"
            ></MemberDropDown>
            <span class="small">Untuk User Level Admin atau Level Normal User.</span>
          </b-form-group>
          <b-button
            :variant="'primary'"
            :size="'sm'"
            :disabled="isChangeMemberDisabled"
            @click="updateMemberUser(selectedUser.id)"
          >{{'Change Member'}}
          </b-button>
        </b-row>
      </b-card>

      <div v-else class="p-5 text-center text-muted">
        <b-icon icon="exclamation-triangle-fill" variant="warning" font-scale="2" />
        <div class="mt-2">Data tidak ditemukan.</div>
      </div>
    </b-modal>

    <!-- Modal Delete User -->
    <b-modal
      v-model="showDeleteModal"
      id="deleteUserModal"
      ref="deleteUserModal"
      title="Delete User Confirmation"
      hide-header-close
      centered
      ok-title="Delete"
      ok-variant="danger"
      cancel-title="Cancel"
      @ok="deleteUserConfirmed"
    >
      <div class="text-center">
        <b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="2"></b-icon>
        <h4 class="mt-3">Are you sure you want to delete <b>{{ user && user.username }}</b>?</h4>

        <p class="text-danger mb-0">This action <b>cannot be undone</b>!</p>
      </div>
    </b-modal>

  </content-wrapper>
</template>

<script>
import MemberDropDown from "@/components/composable/MemberDropDown";
import {
  BIcon,
  BIconPlusCircleFill,
  // BInputGroup, BFormInput,
} from "bootstrap-vue";
import {
  updateSim, updateKtp,
  deleteUserById, accessLevelUserUpdate,
  searchUser, getUserDetail, memberUserUpdate,
  addUser, listUser, setUserStatus
} from "@/services/users";
import {validationMixin} from "vuelidate";
import {required, minLength, email} from "vuelidate/lib/validators";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import SimplePagination from "@/components/SimplePagination";

export default {
  name: "UserList",
  components: {
    MemberDropDown,
    BIcon,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill,
    SimplePagination,
  },
  mixins: [validationMixin, userInfoMixin],
  validations: {
    user: {
      username: {
        required,
        minLength: minLength(3),
      },
      user_mail: {
        required,
        minLength: minLength(5),
        email,
      },
      level: {
        required,
      },
    },
  },
  data: () => ({
    isDisabled: false,
    isDeleteLoading: false,
    showDeleteModal: false,
    selectedUser: null,
    isDetailLoading: false,
    showDetailModal: false, // untuk modal popup
    items: [],    // hasil filter
    categories: ['ID','Username','Email','Level'],
    selectedCategory: "Username", // default
    searchQuery: "",
    options: {
      user: [
        {text: 'NEW', value: 0}, // newly created user, and not yet activate
        {text: 'ACTIVE', value: 1},
        {text: 'INACTIVE', value: 2},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
    },
    columns: [
      {
        key: 'id',
        label: 'ID',
      },
      {
        key: 'username',
        label: 'Username',
      },
      {
        key: 'user_mail',
        label: 'Email',
      },
      {
        key: 'level',
        label: 'Level',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Actions',
      },
      // { key: 'details', label: '', thStyle: { width: '1px' } },
    ],
    isLoading: false,
    status: [
      {0: 'danger', 1: 'primary', 2: 'danger',},
      {0: 'NEW', 1: 'Enable', 2: 'Inactive'},
    ],
    user: {
      username: "",
      level: 2, // blm tau apa ini, sementara fix 1 dulu
      user_type: 1, // ini jg fix 1 dulu
      user_mail: "",
    },
    isSubmitting: false,
    password: null,
    pagination: {
      current: 1,
      last_page: 15,
      total_items: 0,
      per_page: 10,
      at_last_page: false,
    },
    searchForm: {
      keywords: null,
      type: null,
      status: 0,
    },
    showImageModal: false,
    imagePreviewSrc: null,
  }),
  methods: {
    async updateAccessLevelUser(id){
      this.isDetailLoading = true;

      try {
        await accessLevelUserUpdate({
          user_id:id,
          role:this.user.level
        });

        this.handleSearch();
        this.$bvToast.toast('Berhasil update access level user.', { variant: 'success' });

      } catch (error) {

        this.$bvToast.toast('Gagal update access level user.', { variant: 'danger' });
        this.showDetailModal = false;

      }

      this.showDetailModal = false;
    },
    changeLevel(){
      // console.log('this.user.level',this.user.level)
    },
    async updateMemberUser(id){
      this.isDetailLoading = true;

      try {
        await memberUserUpdate({
          user_id:id,
          member:this.selectedMember
        });

        this.$bvToast.toast('Berhasil update member user.', { variant: 'success' });

      } catch (error) {

        this.$bvToast.toast('Gagal update member user.', { variant: 'danger' });
        this.showDetailModal = false;

      }

      this.showDetailModal = false;
    },
    changeMember(member){
      this.selectedMember = member.value.id
    },
    async deleteUserConfirmed() {
      if (!this.user || !this.user.id) {
        this.$bvToast.toast('No user selected for delete!', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 1500,
        });
        return;
      }
      this.isSubmitting = true; // Optional: buat indikator loading, harus ada di data()
      try {

        await deleteUserById({id:this.user.id})

        this.$bvToast.toast(`User deleted!`, {
          title: 'Success',
          variant: 'success',
          autoHideDelay: 1500,
        });

        // Tutup modal delete
        this.showDeleteModal = false;

        // Reset state userToDelete
        this.user.id = null;
        this.user.username = null;

        // Refresh table atau list user
        this.searchQuery = '';
        this.$refs.table && this.$refs.table.refresh && this.$refs.table.refresh();

      } catch (e) {
        this.$bvToast.toast(e.message || 'Failed to delete user!', {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 2000,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    deleteUser(user){
      console.log('delUser', user.id);
      this.user.id = user.id;
      this.user.username = user.username;

      this.isDeleteLoading = true;
      this.showDeleteModal = true;
    },
    async editUser(user) {
      this.isDetailLoading = true;
      this.selectedUser = null;
      this.showDetailModal = true;

      try {
        const data = JSON.parse(await getUserDetail(user.id));
        this.selectedUser = data.user;
        // clear any previous file selections/previews
        this.$set(this.selectedUser, 'simFile', null);
        this.$set(this.selectedUser, 'ktpFile', null);
        this.$set(this.selectedUser, 'simPreview', null);
        this.$set(this.selectedUser, 'ktpPreview', null);
        this.user.level = this.selectedUser.level;
      } catch (err) {
        this.$bvToast.toast('Gagal ambil detail user', { variant: 'danger' });
        this.showDetailModal = false;
      }
      this.isDetailLoading = false;
    },

    onSimFileChange(e) {
      const file = e && e.target && e.target.files ? e.target.files[0] : null;
      if (!file) return;
      if (!this.selectedUser) return;
      // revoke previous preview if any
      if (this.selectedUser.simPreview) {
        URL.revokeObjectURL(this.selectedUser.simPreview);
      }
      this.selectedUser.simFile = file;
      this.selectedUser.simPreview = URL.createObjectURL(file);
    },
    onKtpFileChange(e) {
      const file = e && e.target && e.target.files ? e.target.files[0] : null;
      if (!file) return;
      if (!this.selectedUser) return;
      if (this.selectedUser.ktpPreview) {
        URL.revokeObjectURL(this.selectedUser.ktpPreview);
      }
      this.selectedUser.ktpFile = file;
      this.selectedUser.ktpPreview = URL.createObjectURL(file);
    },
    async uploadSingleFile(type) {
      // Convert selected file to base64 and call the appropriate service
      if (!this.selectedUser) return;
      const file = type === 'sim' ? this.selectedUser.simFile : this.selectedUser.ktpFile;
      if (!file) {
        this.$bvToast.toast('No file selected', { variant: 'warning' });
        return;
      }

      this.isDetailLoading = true;
      try {
        // send the raw File to the service which will wrap it into FormData
        if (type === 'sim') {
          console.log(await updateSim({ user_id: this.selectedUser.id, file }));
        } else {
          await updateKtp({ user_id: this.selectedUser.id, file });
        }

        this.$bvToast.toast(`${type.toUpperCase()} uploaded`, { variant: 'success' });

        // refresh user details to pick up server-side URL
        const data = JSON.parse(await getUserDetail(this.selectedUser.id));
        this.selectedUser = data.user;
        // clear file/preview
        this.$set(this.selectedUser, 'simFile', null);
        this.$set(this.selectedUser, 'ktpFile', null);
        this.$set(this.selectedUser, 'simPreview', null);
        this.$set(this.selectedUser, 'ktpPreview', null);
      } catch (err) {
        console.error(err);
        this.$bvToast.toast('Upload failed', { variant: 'danger' });
      } finally {
        this.isDetailLoading = false;
      }
    },
    openImagePreview(src) {
      if (!src) return;
      this.imagePreviewSrc = src;
      this.showImageModal = true;
    },
    selectCategory(category){
      this.selectedCategory = category;
    },
    async handleSearch() {
      const keyMap = {
        'Username': 'username',
        'ID': 'id',
        'Email': 'user_mail',
        'Level': 'level'
      };
      
      const query = (this.searchQuery || '').toString().toLowerCase();
      
      if (query == '') {
        this.isDisabled = false;
        this.$refs.table.refresh();
        return;
      }

      let search = await searchUser({
        category: keyMap[this.selectedCategory],
        search: this.searchQuery
      });

      let found = JSON.parse(search).found;
      
      this.items = found;
      this.isDisabled = true;
      this.$refs.table.refresh();
    },
    loadUserByMember(member) {
      this.selectedMember = member;
      this.$refs.table.refresh();
    },
    edit(user) {
      this.user = user;
      this.user = {
        username: user.username,
        level: user.level, // blm tau apa ini, sementara fix 1 dulu
        user_type: user.user_type, // ini jg fix 1 dulu
        user_mail: user.user_mail,
      };

      this.$bvModal.show('formModal')
    },
    async setStatus(user) {
      this.isLoading = true;
      const status = user.status !== 1 ? 1 : 2;
      
      await setUserStatus({username: user.username, status,})
      this.handleSearch();

      this.isLoading = false;
      this.$bvToast.toast(`${user.username} Status Updated!`, {
        title: 'Congratulation!',
        autoHideDelay: 1500,
        variant: 'success',
      })
      this.$nextTick(() => {
        this.$refs.table.refresh();
      });
    },
    clearForm() {
      this.user = {
        member: 0,
        username: "",
        level: 2, // blm tau apa ini, sementara fix 1 dulu
        user_type: 1, // ini jg fix 1 dulu
        user_mail: "",
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async submit() {
      try {
        this.$v.user.$touch();
        if (this.$v.user.$anyError) {
          this.$bvToast.toast(`Missing required information!`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }

        this.isSubmitting = true;
        
        const {data: {data: {user}}} = await addUser(this.user)

        this.$bvToast.toast(`${this.user.username} saved successfully!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.password = user.paswd;
        this.$bvModal.hide('formModal')
        this.clearForm();
        this.$bvModal.show('credential')
        this.loadUserByMember(this.selectedMember)
        this.isSubmitting = false
      } catch (err) {
        this.isSubmitting = false;
        this.$nextTick(() => {
          this.$v.$reset();
        });
      }
    },
    add() {
      this.clearForm();
      if (!this.isSuperAdmin) {
        this.user.member = this.member.id
      }
      this.$bvModal.show('formModal')
    },
    validate() {
      return true;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    setMember(member) {
      delete this.user.member
      if (member !== null) {
        this.user.member = member.id ?? member.value.id
      }
    },
    async loadPage(ctx){
      try {
        if(this.searchQuery != ''){
          return this.items;
        }

        this.isLoading = true;
        const {data: {data: {rows}}} = await listUser(this.searchParams(ctx))
        const all = Array.isArray(rows.user) ? rows.user : [rows.user];
        
        this.pagination.total_items = all.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        this.isLoading = false;

        // Filter awal (default: tanpa filter)
        this.items = all;
        return this.items;

      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    searchParams(ctx){
      const searchData = {
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
        status: this.searchForm.status,
      };
      if (this.selectedMember !== null) {
        searchData['member'] = this.selectedMember.id
      }
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc' : 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      return searchData;
    },
  },
  computed: {
    level() {
      const levels = [
        {text: 'Admin', value: 2},
        {text: 'Normal User', value: 3},
      ]
      if (this.isSuperAdmin) {
        levels.unshift({text: 'Super Admin', value: 1,})
        levels.push({text: 'Control Room', value: 4,});
        levels.push({text: 'Gate Pass', value: 5,});
      }
      return levels;
    },
    isChangeMemberDisabled() {
      return !(this.selectedUser.level === 2 || this.selectedUser.level === 3);
    }
  },
  mounted() {
    if (!this.isSuperAdmin) {
      this.user.member = this.member.id
    }
    this.loadUserByMember(this.member)
  },
}
</script>

<style scoped>
.img-clickable {
  cursor: pointer;
}

.action-btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.action-btn-group .btn {
  white-space: nowrap;
}

.user-doc-image,
.user-doc-placeholder {
  width: 100%;
  max-width: 500px;
  aspect-ratio: 4 / 4;
}

.user-doc-image {
  object-fit: cover;
}

.user-doc-placeholder {
  background: #f5f5f5;
}

@media (max-width: 576px) {
  .action-btn-group .btn {
    flex: 1 1 100%;
  }

  .user-doc-image,
  .user-doc-placeholder {
    max-width: 100%;
  }
}
</style>
